import { useMemo, useState } from 'react'

import { local } from '../lib/sync'
import type { Client } from '../types'
import { IconChevron } from './icons'
import { useLocal } from './useLocal'

export default function Clients({ onOpen }: { onOpen: (id: number) => void }) {
  const { rows: clients } = useLocal<Client>(local.clients)
  const [q, setQ] = useState('')

  const shown = useMemo(() => {
    const needle = q.trim().toLowerCase()
    return clients
      .filter((c) => c.is_active)
      .filter((c) => {
        if (!needle) return true
        return (
          c.name.toLowerCase().includes(needle) ||
          (c.contact_person ?? '').toLowerCase().includes(needle) ||
          (c.phone ?? '').includes(needle) ||
          (c.inn ?? '').includes(needle)
        )
      })
      .sort((a, b) => a.name.localeCompare(b.name, 'ru'))
  }, [clients, q])

  return (
    <>
      <div className="m-head" style={{ paddingBottom: 18 }}>
        <div className="m-head-row">
          <div className="m-head-name">Клиенты</div>
        </div>
        <input
          className="m-input"
          style={{ marginTop: 14, background: 'rgba(255,255,255,0.10)', border: '1px solid rgba(156,197,220,0.28)', color: '#fff' }}
          placeholder="Название, ИНН, телефон"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      {shown.length === 0 && <div className="m-empty">Ничего не найдено</div>}

      <div className="m-list" style={{ marginTop: 14 }}>
        {shown.map((c) => (
          <div key={c.id} className="m-card" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button className="m-rowbtn" onClick={() => onOpen(c.id)}>
              <div className="m-client">{c.name}</div>
              <div className="m-sub" style={{ marginTop: 4 }}>
                {c.accesses_count > 0 ? `доступов: ${c.accesses_count}` : 'доступов нет'}
                {c.contacts_count > 0 && ` · контактов: ${c.contacts_count}`}
              </div>
            </button>
            <IconChevron color="#94a3b8" />
          </div>
        ))}
      </div>

      <div style={{ height: 20 }} />
    </>
  )
}
